import { Component, Input } from '@angular/core';
import { ScenariosViewModel } from '@store/scenario/scenarios/scenarios-slice';
import { ScenariosResultListComponent } from '../scenarios-result-list/scenarios-result-list.component';
import { IconComponent } from '@totalenergiescode/tds-angular';

@Component({
    selector: 'app-scenarios-result-list-container',
    templateUrl: './scenarios-result-list-container.component.html',
    styleUrl: './scenarios-result-list-container.component.scss',
    imports: [ScenariosResultListComponent, IconComponent]
})
export class ScenariosResultListContainerComponent {
  @Input()
  viewModel!: ScenariosViewModel | null;
}
